/**
 * @generated SignedSource<<8fca9f9fe0ac68d1d3214ecf18e56303>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsCateringEditPageQuery$variables = {
  id: string;
};
export type SettingsCateringEditPageQuery$data = {
  readonly cateringOption: {
    readonly etgKey: string | null;
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CateringEditForm_cateringOption" | "CateringSidebar_cateringOption">;
  } | null;
};
export type SettingsCateringEditPageQuery = {
  response: SettingsCateringEditPageQuery$data;
  variables: SettingsCateringEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "etgKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsCateringEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CateringOption",
        "kind": "LinkedField",
        "name": "cateringOption",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CateringEditForm_cateringOption"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CateringSidebar_cateringOption"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsCateringEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CateringOption",
        "kind": "LinkedField",
        "name": "cateringOption",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayInSearch",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b27014cb5f16f606f0a82bbec196e212",
    "id": null,
    "metadata": {},
    "name": "SettingsCateringEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsCateringEditPageQuery(\n  $id: ID!\n) {\n  cateringOption(id: $id) {\n    name\n    etgKey\n    ...CateringEditForm_cateringOption\n    ...CateringSidebar_cateringOption\n    id\n  }\n}\n\nfragment CateringEditForm_cateringOption on CateringOption {\n  id\n  name\n  etgKey\n  displayInSearch\n}\n\nfragment CateringSidebar_cateringOption on CateringOption {\n  ...EntitySidebar_entity\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "00455d34eca5d4955b725d873a2f3179";

export default node;
